import { Platform, StyleSheet } from 'react-native'
import type { Theme } from '../src/theme/getTheme'

/**
 * Public marketing home (`/`): the page scrolls with the **document** (normal browser scrollbar),
 * not a nested RN scroll container. Avoid `flex: 1` on web here; it can create a second, tiny
 * scrollable region inside a fixed-height root and shows double scrollbars.
 */
export function getLandingNewPageStyles(theme: Theme) {
  return StyleSheet.create({
    scroll: {
      ...(Platform.OS === 'web'
        ? { minHeight: '100vh' as never, width: '100%' as never }
        : { flex: 1 }),
      backgroundColor: theme.background.primary,
    },
    scrollContent: {
      flexGrow: 1,
    },
    drawerColumn: {
      ...(Platform.OS === 'web' ? { width: '100%' as never } : { flex: 1 }),
    },
    pageBody: {
      width: '100%' as never,
      backgroundColor: theme.background.primary,
    },
  })
}
